import React from 'react';

import { findLeader, SplitHouseholds } from '../../helpers/households';
import { Checkbox } from '@xo-union/tk-component-switches';

interface Props {
  households: SplitHouseholds;
  selectedHouseholds: Set<string>;
  setSelectedHouseholds: React.Dispatch<React.SetStateAction<Set<string>>>;
}

const SelectAllCheckbox: React.FC<Props> = ({ households, selectedHouseholds, setSelectedHouseholds }) => {
  const onSelectAll = () => {
    if (isSelectedAll()) {
      // In this case, we are unchecking the box.
      setSelectedHouseholds(new Set([]));
    } else {
      const allSelectableHouseholds = households.contactable.map(house => {
        return findLeader(house)?.id || '';
      });
      setSelectedHouseholds(new Set(allSelectableHouseholds));
    }
  };

  const isSelectedAll = () => {
    return selectedHouseholds.size === households.contactable.length;
  };

  return <Checkbox onChange={onSelectAll} checked={isSelectedAll()} />;
};

export default SelectAllCheckbox;
